@if (items) {
  <mb-section-headline [headline]="headline" [anchor]="anchor">
    <mb-dropdown
      [hideLabel]="true"
      class="d-md-none"
      [class.active]="activeFilter && activeFilter.value !== 'ALL'"
      [value]="$safeNavigationMigration(activeFilter?.value)"
      [options]="filters"
      [icon]="activeFilter?.value === 'ALL' ? 'mb-icon-filter' : 'mb-icon-filter-flat'"
      (selectionChanged)="filter($event)"
    ></mb-dropdown>
  </mb-section-headline>
  <mb-ribbon-slider-section
    class="show-navigation"
    [config]="config"
    [itemWrapperClasses]="['col-12 col-xs-6 col-md-4 col-lg-3']"
    [items]="activeTeasers"
    [filters]="filters"
    (filtered)="filter($event)"
    [stickyFilters]="stickyFilters"
    [mobileFilter]="false"
    [filterWrapperClasses]="['col-2']"
    [placeholderOffsetItemClasses]="placeholderOffsetItemClasses"
    containerClass="container-sm"
  >
    <ng-template #itemTemplate let-item="item" let-index="index">
      @if (sectionId) {
        <a [routerLink]="['test-cars', sectionId]" [queryParams]="{ car: index }">
          <mb-test-car-card [data]="item"></mb-test-car-card>
        </a>
      }
      @if (!sectionId) {
        <mb-test-car-card [data]="item"></mb-test-car-card>
      }
    </ng-template>
  </mb-ribbon-slider-section>
}
